import api from './axios';

// Parameters API
export const parametersAPI = {
  getAll: (includeInactive = false, page = 1, limit = 10) =>
    api.get('/parameters', { params: { includeInactive, page, limit } }),
  getAllForDropdown: () => api.get('/parameters', { params: { all: 'true' } }),
  getById: (id) => api.get(`/parameters/${id}`),
  create: (data) => api.post('/parameters', data),
  update: (id, data) => api.patch(`/parameters/${id}`, data),
  toggle: (id) => api.patch(`/parameters/${id}/toggle`)
};

export default parametersAPI;
